import React, { useEffect } from "react";
import { usePohrebka2 } from "../../context/Pohrebka2Context";

const cardStyle = {
  background: "#fff",
  border: "1px solid #e5e7eb",
  borderRadius: 24,
  padding: 24,
  boxShadow: "0 10px 30px rgba(15,23,42,0.06)",
};

const gridStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
  gap: 16,
};

const labelStyle = {
  display: "block",
  fontSize: 14,
  fontWeight: 700,
  color: "#111827",
  marginBottom: 8,
};

const inputStyle = {
  width: "100%",
  padding: "12px 14px",
  borderRadius: 14,
  border: "1px solid #d1d5db",
  fontSize: 15,
  background: "#fff",
  outline: "none",
  boxSizing: "border-box",
};

const textareaStyle = {
  ...inputStyle,
  minHeight: 120,
  resize: "vertical",
};

export default function Pohrebka2ZesnulaForm() {
  const { order, patchSection, currentOrderId } = usePohrebka2();

  useEffect(() => {
    const handler = (e) => {
      const full = String(e?.detail?.zesnuly || "").trim();
      if (!full) return;

      const parts = full.split(/\s+/).filter(Boolean);
      const jmeno = parts.shift() || "";
      const prijmeni = parts.join(" ");

      patchSection("zesnulaOsoba", {
        ...(jmeno ? { jmeno } : {}),
        ...(prijmeni ? { prijmeni } : {}),
      });
    };

    window.addEventListener("pohrebka2-calendar-create-date", handler);
    return () => window.removeEventListener("pohrebka2-calendar-create-date", handler);
  }, [patchSection]);
  const v = order?.zesnulaOsoba || {};

  const setField = (name, value) => {
    const val = String(value || "");

    if (name === "jmeno" || name === "prijmeni") {
      const current = order?.zesnulaOsoba || {};
      const nextJmeno = name === "jmeno" ? val : String(current?.jmeno || "").trim();
      const nextPrijmeni = name === "prijmeni" ? val : String(current?.prijmeni || "").trim();
      const fullName = [nextJmeno, nextPrijmeni].filter(Boolean).join(" ").trim();

      patchSection("zesnulaOsoba", { [name]: val });
      if (fullName) {
        patchSection("zaklad", { zesnuly: fullName });
      }
      return;
    }

    if (name === "datumUmrti" || name === "casUmrti" || name === "mistoUmrti" || name === "adresaUmrti") {
      patchSection("zesnulaOsoba", { [name]: val });

      const prevozPatch = {};
      if (name === "mistoUmrti") prevozPatch.mistoOdvozu = val;
      if (name === "adresaUmrti") prevozPatch.adresaOdvozu = val;

      if (Object.keys(prevozPatch).length) {
        patchSection("prevoz", prevozPatch);
      }

      return;
    }

    patchSection("zesnulaOsoba", { [name]: val });
  };

  return (
    <div style={cardStyle}>
      <div style={{ display: "flex", justifyContent: "space-between", gap: 16, flexWrap: "wrap", marginBottom: 20 }}>
        <div>
          <div style={{ fontSize: 34, fontWeight: 900, color: "#111827", lineHeight: 1.05 }}>Zesnulá osoba</div>
          <div style={{ marginTop: 8, color: "#6b7280", fontSize: 16 }}>
            Detailní údaje o zesnulé osobě.
          </div>
        </div>
        <div style={{ textAlign: "right" }}>
          <div style={{ fontSize: 14, color: "#6b7280", fontWeight: 700 }}>Aktivní zakázka</div>
          <div style={{ fontSize: 28, fontWeight: 900, color: "#111827" }}>{currentOrderId || "-"}</div>
        </div>
      </div>

      <div style={gridStyle}>
        <div>
          <label style={labelStyle}>Jméno</label>
          <input type="text" value={v.jmeno || ""} onChange={(e) => setField("jmeno", e.target.value)} style={inputStyle} />
        </div>

        <div>
          <label style={labelStyle}>Příjmení</label>
          <input type="text" value={v.prijmeni || ""} onChange={(e) => setField("prijmeni", e.target.value)} style={inputStyle} />
        </div>

        <div>
          <label style={labelStyle}>Rodné číslo</label>
          <input type="text" value={v.rodneCislo || ""} onChange={(e) => setField("rodneCislo", e.target.value)} style={inputStyle} />
        </div>

        <div>
          <label style={labelStyle}>Datum narození</label>
          <input type="date" value={v.datumNarozeni || ""} onChange={(e) => setField("datumNarozeni", e.target.value)} style={inputStyle} />
        </div>

        <div>
          <label style={labelStyle}>Datum úmrtí</label>
          <input type="date" value={v.datumUmrti || ""} onChange={(e) => setField("datumUmrti", e.target.value)} style={inputStyle} />
        </div>

        <div>
          <label style={labelStyle}>Čas úmrtí</label>
          <input type="text" value={v.casUmrti || ""} onChange={(e) => setField("casUmrti", e.target.value)} style={inputStyle} placeholder="např. 14:30" />
        </div>

        <div>
          <label style={labelStyle}>Místo úmrtí</label>
          <input type="text" value={v.mistoUmrti || ""} onChange={(e) => setField("mistoUmrti", e.target.value)} style={inputStyle} />
        </div>

        <div>
          <label style={labelStyle}>Adresa úmrtí</label>
          <input type="text" value={v.adresaUmrti || ""} onChange={(e) => setField("adresaUmrti", e.target.value)} style={inputStyle} />
        </div>

        <div>
          <label style={labelStyle}>Trvalé bydliště</label>
          <input type="text" value={v.trvaleBydliste || ""} onChange={(e) => setField("trvaleBydliste", e.target.value)} style={inputStyle} />
        </div>

        <div>
          <label style={labelStyle}>Státní občanství</label>
          <input type="text" value={v.narodnost || ""} onChange={(e) => setField("narodnost", e.target.value)} style={inputStyle} />
        </div>
      </div>

      <div style={{ marginTop: 18 }}>
        <label style={labelStyle}>Poznámka</label>
        <textarea
          value={v.poznamka || ""}
          onChange={(e) => setField("poznamka", e.target.value)}
          style={textareaStyle}
          placeholder="Doplňující poznámka"
        />
      </div>
    </div>
  );
}
